import { useState, useEffect, useRef } from 'react';

// Tracks a DOM element's live width via ResizeObserver. Backs TimeSeriesChart's
// viewport-width-aware tick density (see lib/timeSeriesChart.js's getTickCount) — no chart
// in the app adapted tick count to actual available width before this (docs/TODO.md v1.0.0 §1).
export default function useContainerWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    // No ResizeObserver (jsdom, an old WebView): stay at 0 and let the caller fall back.
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) setWidth(entry.contentRect.width);
    });
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return [ref, width];
}
